import Drawer from "@material-ui/core/Drawer";
import styled from 'styled-components';

const mainFont = 'Open Sans, sans-serif';

export const StyledDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    background-color: ${({theme}) => theme.sidebar.background};
    border-right: 1px solid ${({theme}) => theme.surface.border};
  }

  .sidebar {
    &__arrow-bar {
      height: 45px;
      width: 45px;
    }
  }

  .sidebar-menu {
    padding: 10px 0 0;
    overflow-x: hidden;
    overflow-y: auto;
    overflow-scrolling: touch;

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 3px;
      height: 0;
      background-color: ${({theme}) => theme.sidebar.scrollTrack};
      display: none;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background-color: ${({theme}) => theme.sidebar.scrollThumb};
      display: none;
    }

    &:hover {
      &::-webkit-scrollbar {
        display: block;
      }

      &::-webkit-scrollbar-thumb {
        display: block;
      }
    }

    &__item {
      padding: 12px 0;
      
      &:hover {
        background-color: ${({theme}) => theme.sidebar.itemHoverBackground};
      }

      @media screen and (max-width: 599px) {
        padding: 10px 0;
      }
    }

    &__text span {
      color: ${({theme}) => theme.sidebar.itemColor};
      font-family: ${mainFont};
      font-size: 14px;
      font-weight: 600 !important;
      
      @media screen and (max-width: 599px) {
        font-size: 14px;
      }
    }

    &__icon {
      min-width: 57px;
      padding-left: 0;
      justify-content: center;
      font-size: 20px;
      @media screen and (max-width: 960px) {
        padding-left: 0;
        font-size: 18px;
      }
      @media screen and (max-width: 599px) {
        min-width: 45px;
      }
    }

    .active {
      background: ${({theme}) => theme.sidebar.activeBackground};
      position: relative;

      .sidebar-menu__text span {
        color: ${({theme}) => theme.sidebar.activeColor};
      }

      .sidebar-menu__icon {
        color: ${({theme}) => theme.sidebar.activeColor};
      }

      &:after {
        content: '';
        height: 100%;
        width: 5px;
        background: ${({theme}) => theme.sidebar.activeBar};
        border-radius: 5px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
  
  @media screen and (max-width: 992px) {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const StyledDivider = styled.div`
  height: 50px;
  @media screen and (max-width: 599px) {
    height: 25px;
  }
`;

export const StyledDrawerOpen = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  transition: all .3s ease;
  @media screen and (max-width: 992px) {
    padding: 0 13px;
  }
`;

export const StyledSidebarLogo = styled.button`
  width: 100%;
  display: grid;
  grid-template-columns: 45px 1fr;
  grid-gap: 5px;
  align-items: end;
  .sidebar-logo__icon {
    width: 45px;
    padding-bottom: 5px;
    filter: ${({theme}) => theme.brand.logoFilter};
  }
  .sidebar-logo__title {
    color: ${({theme}) => theme.sidebar.logoColor};
    font-family: ${mainFont};
    font-size: 22px;
    font-weight: 800;
    text-align: left;
    //@media screen and (max-width: 599px) {
    //  font-size: 18px;
    //}
  }

  @media screen and (max-width: 992px) {
    grid-template-columns: 30px 1fr;
    .sidebar-logo__icon {
      width: 30px;
    }
  }
`;
